/*
 *
 * CommerceWebTenantPopup
 *
 */
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import CommerceWebTenantPopup from './CommerceWebTenantPopup'
import * as HomepageActions from 'Route/Homepage/modules/HomepageActions'
import { doHidePopup } from 'Store/actions/popup'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(HomepageActions, dispatch),
  ...bindActionCreators({ doHidePopup }, dispatch)
})

const mapStateToProps = state => ({
  isLoading: nullSafe(() => state.loading.localLoading.get_url_for_commerce_web || state.loading.localLoading.get_url_for_commerce_web_iam, false),
  flow: nullSafe(() => state.popup.popupInfo.flow, undefined),
  tenants: nullSafe(() => state.popup.popupInfo.tenants, ['isp', 'nexid']),
  widget: nullSafe(() => state.popup.popupInfo.widget, null)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(CommerceWebTenantPopup)
